import FingerprintJS from '@fingerprintjs/fingerprintjs'
// const undef = void (0)

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || 'Y-M-D H:m:s'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    Y: date.getFullYear(),
    M: date.getMonth() + 1,
    D: date.getDate(),
    H: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    S: date.getMilliseconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/(Y|M|D|H|m|s|S|a)+/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/**
 * 把对象转化为
 *
 * @export
 * @param {*} obj
 * @returns
 */
export function objectToQuery(obj) {
  const queryList = []

  if (typeof obj !== 'object') return ''

  Object.keys(obj).forEach(key => {
    const t = typeof obj[key]
    if (t === 'number' || t === 'string' || t === 'boolean') {
      queryList.push(`${key}=${obj[key]}`)
    } else {
      queryList.push(`${key}=${JSON.stringify(obj[key])}`)
    }
  })

  return queryList.join('&')
}

export const ls = {
  getItem(key, defaultValue) {
    let value = localStorage.getItem(key)
    try {
      if (value !== null) {
        value = JSON.parse(value)
      } else {
        return defaultValue
      }
    } catch (error) {
      // console.error(error)
      return value
    }

    return value
  },

  setItem(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },

  removeItem(key) {
    localStorage.removeItem(key)
  }
}

/**
 *
 * @param {Any} value
 * @param {Any} default 转换成数字失败则返回此值
 */
export const toNumber = function(value, defaultValue = null) {
  if (value === null || value === undefined) return defaultValue

  return isNaN(parseInt(value)) ? defaultValue : parseInt(value)
}

export const foreignKey = function(value, defaultValue = 0) {
  if (typeof value === 'number') {
    return value
  } else {
    return isNaN(Number(value)) ? defaultValue : Number(value)
  }
}

// 判断是否是正式环境
export const isProd = function() {
  return process.env.NODE_ENV === 'production' && location.hostname === 'tmecp.tencentmusic.com'
}

// 进入全屏模式
function enterFullscreen() {
  var element = document.documentElement // 获取整个文档的根元素

  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) { // Firefox
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) { // Chrome, Safari 和 Opera
    element.webkitRequestFullscreen()
  } else if (element.msRequestFullscreen) { // IE/Edge
    element.msRequestFullscreen()
  }
}

// 退出全屏模式
function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) { // Firefox
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) { // Chrome, Safari 和 Opera
    document.webkitExitFullscreen()
  } else if (document.msExitFullscreen) { // IE/Edge
    document.msExitFullscreen()
  }
}

// 切换全屏模式
export function toggleFullscreen() {
  if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
    exitFullscreen()
  } else {
    enterFullscreen()
  }
}

/**
 * 获取用户设备指纹，浏览器环境只能保证同一个浏览器、同一个用户、同一个设备，返回的设备指纹是一样的
 * @returns {Promise<string>} 返回一个字符串，表示唯一设备标识
 */
export async function getFingerprint() {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  return result.visitorId
}
